<template>
  <div>
    <el-header ref="header" class="header" style="height: auto;margin-bottom: 10px">
      <el-form :inline="true" :model="searchForm" ref="searchFormRef" class="demo-form-inline">
        <div id="searchBox">
          <el-form-item label="" prop="company">
            <el-input placeholder="请输入公司名称" v-model="searchForm.company"  @keydown.enter.native="handleSearchBtn"/>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="text" style="margin-left:10px" id="closeSearchBtn" @click="closeSearch">
            {{ word }}
            <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
          </el-button>
          <el-button type="primary" size="small" @click="handleSearchBtn()" icon="el-icon-search">搜索
          </el-button>
          <el-button size="small" @click="handleResetBtn" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <div class="custom-table search-table">
      <el-button type="primary" size="small" class="el-icon-plus custom-btn" @click="handleAdd">新增客户</el-button>
      <el-dialog :visible.sync="dialogVisible" title="指定联系人" width="30%">
        <el-form ref="dialogFormRef" :model="dialogForm">
           <el-form-item label="" prop="assign" :rules="[{required:true,trigger:'change',message:'请指定联系人！'}]">
             <el-select v-model="dialogForm.assign" clearable filterable>
               <el-option v-for="item in assignData" :label="item.rname" :value="item.yid" :key="item.yid">{{item.rname}}</el-option>
             </el-select>
           </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleDialogCancel">取 消</el-button>
          <el-button type="primary" @click="handleDialogSubmit" :loading="submitLoading">确 定</el-button>
        </div>
      </el-dialog>
      <el-table border fit highlight-current-row class="customer-table" :data="list">
        <el-table-column label="序号" prop="id"></el-table-column>
        <el-table-column label="客户类别" prop="classname"></el-table-column>
        <el-table-column label="公司名称" prop="company">
          <template v-slot="scope">
            <router-link
              :to="{ name: 'generateContract', params: { id: scope.row.id } }"
              class="el-link el-link--primary is-underline"
            >
              {{ scope.row.company }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column label="联系人" prop="name"></el-table-column>
        <el-table-column label="手机/电话" prop="phone"></el-table-column>
        <el-table-column label="负责人" prop="rname">
          <template v-slot:default="scope">
            <div class="customer-director">
              {{ scope.row.rname }}
              <el-button type="text" size="small" @click="handleAssign(scope.row.id)"
                         class="el-icon-thumb"
              >
                指定
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <el-button type="primary" size="small" @click="handleEdit(scope.row)"
                       class="el-icon-edit-outline"
            >
              编辑
            </el-button>
            <el-popconfirm
              iconColor="red"
              @confirm="handleDelete(scope.row,scope.$index)"
              title="确认删除此条数据吗？"
            >
              <el-button slot="reference" type="danger" size="small" class="el-icon-delete">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                     :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]"
                     :page-size="selectPage.pageSize"
                     background
                     layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                     style="margin-top: 14px;margin-bottom:14px"
      >
      </el-pagination>
    </div>
    <Edit :dialog="dialog" :form-data="editFormData" @submit="handleSubmit" :type="type" @close="handleClose" />
  </div>
</template>
<script>
import { computed, defineComponent, getCurrentInstance, onMounted, reactive, ref } from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue'
import Edit from './edit.vue'
import request from '@/utils/request'
import { Message } from 'element-ui'


export default defineComponent({
  components: { PageWrapper, Edit },
  setup() {
    const showAll = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20
    })
    const allNum = ref(1)
    const dialog = ref(false)
    const type = ref('')
    const editFormData = ref({})
    const list = ref([])
    const keyId = ref(null)
    const dialogVisible = ref(false)
    const dialogFormRef = ref(null)
    const searchFormRef = ref(null)
    const searchForm = reactive({
      company: '',
    })
    const dialogForm = reactive({assign:''})
    const assignData = ref([])
    const parentId = ref(null)

    const instance = getCurrentInstance()
    const username = instance.proxy.$store.getters.name

    const word = computed(() => {
      if (!showAll.value) {
        return '展开'
      } else {
        return '收起'
      }
    })
    const handleAdd = () => {
      dialog.value = true
      type.value = 'add'
      editFormData.value = {}
    }
    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getCustomerInfo()
    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getCustomerInfo()
    }

    const closeSearch = () => {
      showAll.value = !showAll.value
    }

    const handleSearchBtn = () => {
      selectPage.pageNum = 1
      getCustomerInfo()
    }

    const handleResetBtn = () => {
      searchFormRef.value.resetFields()
      getCustomerInfo()
    }

    const getEditForm = (id) => {
      request({
        url: 'customer_info_list2.yy',
        method: 'POST',
        data: {id: id},
      }).then(res => {
         if(res.code == 200){
           editFormData.value = res.data
         }
      })
    }

    const handleEdit = (row) => {
      dialog.value = true
      type.value = 'edit'
      parentId.value = row.id
      getEditForm(row.id)
    }

    const handleDelete = (scope, index) => {
      request({
        url: 'customer_info_delete.yy',
        method: 'post',
        data: { id: scope.id }
      }).then(res => {
        if (res.code == 200) deleteRow(index)
      }).catch(err => {
        Message({ message: err, type: 'error' })
      })
    }

    const deleteRow = (index) => {
      list.value.splice(index, 1)
    }

    onMounted(() => {
      getCustomerInfo()
    })

    const getCustomerInfo = () => {
      request({
        url: 'customer_info_list.yy',
        method: 'post',
        data: {username: username,...searchForm},
        params: selectPage
      }).then((res) => {
        const { code, data,total } = res
        if (code == 200) {
          list.value = data
          allNum.value = total
        }
      })
    }


    const handleSubmit = (formCopy,contactsForm,raddress,remarkForm,invoiceForm) => {
      let data;
      if (type.value === 'add') {
        data = request({
          url: 'customer_info_insert.yy',
          method: 'post',
          data: {
            username: username,
            ...formCopy,
            ...{child_lxr:contactsForm},
            ...{raddress: raddress},
            ...{child_content: remarkForm}
          }
        })
      } else {
        data = request({
          url: 'customer_info_update.yy',
          method: 'post',
          data: {
            ...{id: parentId.value},
            ...formCopy,
            ...{child_lxr:contactsForm},
            ...{raddress: raddress},
            ...{child_content: remarkForm},
              ...invoiceForm
          }
        })
      }
      data.then(res => {
        if (res.code == 200) {
          dialog.value = false
          getCustomerInfo()
        }else if(res.code == 400){
          Message({ message: res.msg, type: 'error' })
        }
      })
    }

    const handleClose = () => {
      dialog.value = false
    }

    //获取负责人列表
    const getAssign = () => {
      request({
        url: 'customer_info_assign.yy',
        method: 'post',
      }).then((res) => {
        const { code, data } = res
        if(code == 200) assignData.value = data
      })
    }

    //指定联系人
    const handleAssign = (id) => {
      dialogVisible.value = true
      parentId.value = id
      getAssign()
    }

    const handleDialogCancel = () => {
      dialogVisible.value = false
    }

    //指定联系人提交
    const submitLoading = ref(false);
    const handleDialogSubmit = () => {
      dialogFormRef.value.validate((valid) => {
        if(valid) {
          submitLoading.value = true
           request({
             url: 'customer_info_choose.yy',
             method: 'post',
             data: {
                id:parentId.value,
               yid: dialogForm.assign
             }
           }).then(res => {
             if(res.code == 200) {
               submitLoading.value = false
               dialogVisible.value = false
               getCustomerInfo()
             }
           })
        }
      })
    }

    return {
      username,
      searchFormRef,
      searchForm,
      dialogVisible,
      showAll,
      dialog,
      editFormData,
      type,
      allNum,
      selectPage,
      word,
      list,
      keyId,
      parentId,
      dialogFormRef,
      dialogForm,
      assignData,
      submitLoading,
      closeSearch,
      handleResetBtn,
      handleSearchBtn,
      handleAssign,
      handleClose,
      handleAdd,
      pageSizeChange,
      pageCurrentChange,
      handleSubmit,
      handleEdit,
      handleDelete,
      deleteRow,
      handleDialogCancel,
      handleDialogSubmit
    }
  }
})
</script>
<style scoped>
.el-icon-edit-outline {
  margin-right: 10px;
}

.el-icon-delete {
  span {
    margin-left: 4px;
  }
}

.customer-director {
  display: flex;
  align-items: center;

  .el-icon-thumb {
    margin-left: 10px;
  }
}
</style>

